<script>
  export let value;
</script>

<div class='live-teams'>
  <div class='live-teams-visitor'>
    <img class='live-teams-visitor-flag' src='img/static/flag/{value.visitor.flag}.svg' alt='{value.visitor.name.en} flag'/>

    <div class='live-teams-visitor-shortcut'> {value.visitor.shortcut.toUpperCase()} </div>

    <div class='live-teams-visitor-score'> {value.score.visitor} </div>
  </div>

  <div class='live-teams-home'>
    <img class='live-teams-home-flag' src='img/static/flag/{value.home.flag}.svg' alt='{value.home.name.en} flag'/>

    <div class='live-teams-home-shortcut'> {value.home.shortcut.toUpperCase()} </div>

    <div class='live-teams-home-score'> {value.score.home} </div>
  </div>
</div>

<style>
  .live-teams {
    display: flex;
    flex-direction: column;
    gap: 7.5px;
  }

  .live-teams-visitor, .live-teams-home {
    display: flex;
    gap: 7.5px;

    width: 105px;
  }

  .live-teams-visitor-flag, .live-teams-home-flag {
    flex-shrink: 0;

    width: calc(20px / 3 * 4);
    height: 20px;

    border-radius: var(--radius-sm);
  }

  .live-teams-visitor-shortcut, .live-teams-home-shortcut {
    flex-grow: 1;

    display: flex;
    align-items: center;

    height: 20px;
  }

  .live-teams-visitor-score, .live-teams-home-score {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;

    width: calc(20px / 3 * 4);
    height: 20px;

    font-weight: bold
  }

  :global(body.dark) .live-teams-visitor-flag, :global(body.dark) .live-teams-home-flag {
    filter: brightness(88%);
  }
</style>
